import React, { useState, useEffect, useRef } from 'react';
import { Filter } from 'lucide-react';

// Column-header filter: a filter icon that opens a small option list on click.
export default function HeaderFilter({ value, onChange, options }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  const active = value !== '';
  return (
    <span className="relative inline-block align-middle" ref={ref}>
      <button type="button" onClick={() => setOpen(o => !o)}
        title="Filter"
        className={`ml-1 p-0.5 rounded ${active ? 'text-primary-600' : 'text-gray-400 hover:text-gray-600'}`}>
        <Filter size={13} className={active ? 'fill-primary-600' : ''} />
      </button>
      {open && (
        <div className="absolute z-30 mt-1 left-0 bg-white border border-gray-200 rounded-md shadow-lg py-1 min-w-[90px]">
          {options.map(o => (
            <button key={o.value} type="button"
              onClick={() => { onChange(o.value); setOpen(false); }}
              className={`block w-full text-left px-3 py-1.5 text-xs normal-case font-normal hover:bg-primary-50 ${String(o.value) === String(value) ? 'bg-primary-50 text-primary-700 font-medium' : 'text-gray-700'}`}>
              {o.label}
            </button>
          ))}
        </div>
      )}
    </span>
  );
}
